import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("cookie_consent");
    if (!stored) setVisible(true);
    else if (stored === "accepted" && typeof window.__initAnalytics === "function") window.__initAnalytics();
  }, []);

  const choose = (value) => {
    localStorage.setItem("cookie_consent", value);
    if (value === "accepted" && typeof window.__initAnalytics === "function") window.__initAnalytics();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-[#121212] border border-white/10 rounded-2xl p-5 shadow-2xl"
          data-testid="cookie-consent-banner"
        >
          <div className="flex items-start gap-3 mb-4">
            <Cookie size={20} className="text-[#ccff00] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-zinc-300 leading-relaxed">
              We use essential local storage to run this site, and (only with your OK) analytics cookies to improve it.
              See our <Link to="/cookies" className="text-[#ccff00] underline">Cookie Policy</Link>.
            </p>
          </div>
          <div className="flex gap-2">
            <button onClick={() => choose("rejected")} className="flex-1 rounded-full border border-white/20 text-white text-xs font-bold uppercase tracking-widest px-4 py-3 hover:bg-white/5 transition-colors" data-testid="cookie-reject-btn">
              Necessary only
            </button>
            <button onClick={() => choose("accepted")} className="flex-1 rounded-full bg-[#ccff00] text-black text-xs font-bold uppercase tracking-widest px-4 py-3 hover:scale-[1.02] transition-transform" data-testid="cookie-accept-btn">
              Accept all
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsentBanner;
